import { render, staticRenderFns } from "./algl.vue?vue&type=template&id=3672a661&scoped=true&"
import script from "./algl.vue?vue&type=script&lang=js&"
export * from "./algl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3672a661",
  null
  
)

export default component.exports